var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm2 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2h4l1.42 2.76c.422.194.827.425 1.21.69l3.07-.18 2 3.46L20 11.3v1.4l1.66 2.57-2 3.46-3.07-.18a8.006 8.006 0 0 1-1.21.69L14 22h-4l-1.42-2.76a8.006 8.006 0 0 1-1.21-.69l-3.07.18-2-3.46L4 12.7v-1.4L2.34 8.73l2-3.46 3.07.18a8 8 0 0 1 1.21-.69L10 2Zm3.59 3.65L12.76 4h-1.52l-.82 1.61-.31.62-.63.3a6.16 6.16 0 0 0-.91.52l-.57.4h-.7l-1.84-.11-.76 1.32 1 1.54.36.58-.06.69a4.7 4.7 0 0 0 0 1.06l.09.65-.39.58-1 1.54.76 1.32 1.84-.11H8l.56.4c.288.199.592.373.91.52l.63.3.31.62.83 1.65h1.52l.83-1.57.31-.62.63-.3c.317-.147.622-.321.91-.52l.57-.4h.7l1.84.11.76-1.32-1-1.54-.39-.58.06-.69c.04-.352.04-.708 0-1.06l-.06-.69.39-.58 1-1.54-.76-1.32-1.84.11h-.7l-.57-.4a6.158 6.158 0 0 0-.91-.52l-.63-.3-.31-.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2096946536daba62fa4c26ff06d946ec.svg";
export { ForwardRef as ReactComponent };